import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEY = "wipplops_offline_queue";
const listeners = new Set();
const QUEUEABLE = /^\/tasks\/[^/]+\/(start|pause|resume|complete|putaway-complete)$/;

export const isQueueable = (method, url) => method === "post" && QUEUEABLE.test(url.replace(API, ""));
export const readQueue = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (q) => { localStorage.setItem(KEY, JSON.stringify(q)); listeners.forEach((fn) => fn(q)); };
export const subscribe = (fn) => { listeners.add(fn); fn(readQueue()); return () => listeners.delete(fn); };
export const queuedTaskIds = () => new Set(readQueue().map((e) => e.taskId));

export function enqueue(url, body) {
  const path = url.replace(API, "");
  const [, taskId, action] = path.match(/^\/tasks\/([^/]+)\/(.+)$/) || [];
  const entry = { id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, path, body, taskId, action, ts: new Date().toISOString(), error: null };
  write([...readQueue(), entry]);
  return entry;
}

export const removeEntry = (id) => write(readQueue().filter((e) => e.id !== id));

let syncing = false;
export async function syncQueue() {
  if (syncing || !navigator.onLine) return { synced: 0, failed: 0 };
  syncing = true;
  let synced = 0, failed = 0;
  try {
    for (const e of readQueue()) {
      try {
        await axios.post(`${API}${e.path}`, e.body || {}, { withCredentials: true, headers: { "X-Offline-Queued-At": e.ts } });
        removeEntry(e.id); synced++;
      } catch (err) {
        if (!err.response) break; // still offline — stop, keep order
        const d = err.response.data?.detail;
        const msg = typeof d === "string" ? d : d?.message || `HTTP ${err.response.status}`;
        if (err.response.status === 400 && /already|current:/i.test(msg)) { removeEntry(e.id); synced++; continue; }
        write(readQueue().map((x) => (x.id === e.id ? { ...x, error: msg } : x)));
        failed++;
      }
    }
  } finally { syncing = false; }
  return { synced, failed };
}
